import { Context } from "@nuxt/types";

import Api from "@/utils/api";

export default class CartItemsApi extends Api {
  readonly url = "/v1/cart_items";

  constructor($axios: Context["$axios"]) {
    super("cartService", $axios);
  }

  async patch({ cartItemId, includes, ...data }: PatchCartItemParams) {
    return await this.request<OneCartItemResponse>({
      method: "PATCH",
      url: `${this.url}/${cartItemId}`,
      params: {
        includes,
      },
      data,
    });
  }

  async post({ includes, ...data }: PostCartItemParams) {
    return await this.request<OneCartItemResponse>({
      method: "POST",
      params: {
        includes,
      },
      data,
    });
  }

  async delete({ ids }: DeleteCartItemParams) {
    return await this.request<void>({
      method: "DELETE",
      params: {
        ids,
      },
    });
  }
}
